/* image-carousel (v20-claude-yeni, 9 Ekim 2026)
 * - Bu dosya her image-carousel bolumunde ayri yukleniyor. Onceden ikinci yukleme ayni seride ikinci bir
 *   30 ms zamanlayici ekliyordu (serit iki kat hizla akiyordu). Artik tek sefer calisir; ayni gorunen hiz icin adim 2 px.
 * - Masaustu kayan serit yalnizca ekranda gorunurken ve sekme aciktayken calisir.
 * - Erisilebilirlik: Flickity secili olmayan her karta aria-hidden koyuyordu; kartlarin icinde link oldugu icin
 *   yapay zeka ajanlari ve ekran okuyucular 6 karttan 5'ini goremiyordu. Gercek kartlar artik gizlenmiyor;
 *   akis icin uretilen kopyalar gizli kalir ve linkleri klavye sirasindan cikarilir (fareyle tiklanabilir).
 * - Hover'da durdurma data-pause-on-hover ozniteligini okur (onceden yanlis isim okunuyordu).
 * - jQuery bagimliligi kaldirildi.
 */
(function () {
  if (window.__imcImageCarouselLoaded) return;
  window.__imcImageCarouselLoaded = true;

  var TICK_MS = 30;
  var CLONE_ATTR = 'data-imc-clone';

  var fixCellAria = function (el) {
    if (!el || !el.classList || !el.classList.contains('image-section__slide')) return;
    if (el.hasAttribute(CLONE_ATTR)) el.setAttribute('aria-hidden', 'true');
    else el.removeAttribute('aria-hidden');
  };

  var patchFlickityCells = function () {
    var proto = window.Flickity && window.Flickity.Cell && window.Flickity.Cell.prototype;
    if (!proto || proto.__imcAriaPatched) return;
    proto.__imcAriaPatched = true;
    ['create', 'select', 'unselect'].forEach(function (name) {
      var orig = proto[name];
      if (typeof orig !== 'function') return;
      proto[name] = function () {
        var r = orig.apply(this, arguments);
        fixCellAria(this.element);
        return r;
      };
    });
  };

  var makeClone = function (node) {
    var c = node.cloneNode(true);
    c.setAttribute(CLONE_ATTR, '');
    c.setAttribute('aria-hidden', 'true');
    c.querySelectorAll('a, button, input, select, textarea, [tabindex]').forEach(function (f) {
      f.setAttribute('tabindex', '-1');
    });
    return c;
  };

  var initTicker = function (slideshowEl) {
    var slides = slideshowEl.querySelectorAll('.slider__slide');
    var allSlideWidths = 0;
    var flickity = null;
    var isPaused = false;
    var inView = false;
    var timer = null;

    slides.forEach(function (slide) {
      allSlideWidths += slide.offsetWidth;
    });

    if (!slideshowEl.classList.contains('flickity-enabled') && allSlideWidths > 0) {
      var originals = Array.prototype.slice.call(slideshowEl.children);
      var duplicateCounter = Math.ceil(slideshowEl.offsetWidth / allSlideWidths) + 1;
      var frag = document.createDocumentFragment();
      for (var i = 0; i < duplicateCounter; i++) {
        originals.forEach(function (n) {
          frag.appendChild(makeClone(n));
        });
      }
      slideshowEl.appendChild(frag);
    }

    var tickerSpeed = slideshowEl.classList.contains('js-slideshow_reverse') ? -2 : 2;

    var update = function () {
      if (isPaused) return;
      if (!flickity || !flickity.slides || !flickity.slideableWidth) return;
      flickity.x = (flickity.x - tickerSpeed) % flickity.slideableWidth;
      flickity.selectedIndex = flickity.dragEndRestingSelect();
      flickity.updateSelectedSlide();
      flickity.settle(flickity.x);
    };

    var start = function () {
      if (!timer) timer = setInterval(update, TICK_MS);
    };
    var stop = function () {
      if (timer) {
        clearInterval(timer);
        timer = null;
      }
    };
    var sync = function () {
      if (inView && !document.hidden) start();
      else stop();
    };

    flickity = new Flickity(slideshowEl, {
      autoPlay: false,
      freeScroll: true,
      prevNextButtons: false,
      pageDots: false,
      draggable: false,
      wrapAround: true,
      selectedAttraction: 0.015,
      friction: 0.25
    });
    flickity.x = 0;
    slideshowEl.classList.add('has-interval');

    var pauseOnHover = function () {
      var v = slideshowEl.getAttribute('data-pause-on-hover') || slideshowEl.getAttribute('data-pouse-on-hover');
      return v === 'true';
    };
    slideshowEl.addEventListener('mouseenter', function () {
      if (pauseOnHover()) isPaused = true;
    });
    slideshowEl.addEventListener('mouseleave', function () {
      if (pauseOnHover()) isPaused = false;
    });

    if ('IntersectionObserver' in window) {
      new IntersectionObserver(
        function (entries) {
          inView = entries[entries.length - 1].isIntersecting;
          sync();
        },
        { rootMargin: '200px 0px' }
      ).observe(slideshowEl);
    } else {
      inView = true;
    }
    document.addEventListener('visibilitychange', sync);

    update();
    sync();
  };

  var imageSlide = function () {
    if (typeof Flickity === 'undefined') return;
    patchFlickityCells();
    var slideshowElements = document.querySelectorAll('.image-section__list');
    var isMobile = window.innerWidth < 768;

    slideshowElements.forEach(function (slideshowEl) {
      if (slideshowEl.dataset.imcCarouselInit === '1') return;
      slideshowEl.dataset.imcCarouselInit = '1';

      if (isMobile) {
        if (!slideshowEl.classList.contains('flickity-enabled')) {
          new Flickity(slideshowEl, {
            autoPlay: false,
            freeScroll: false,
            prevNextButtons: false,
            pageDots: false,
            draggable: true,
            wrapAround: false,
            cellAlign: 'center',
            contain: true
          });
        }
        return;
      }

      initTicker(slideshowEl);
    });
  };

  document.addEventListener('shopify:section:load', function () {
    setTimeout(function () {
      document.querySelectorAll('.image-section__list:not(.flickity-enabled)').forEach(function (el) {
        delete el.dataset.imcCarouselInit;
      });
      imageSlide();
    }, 300);
  });

  imageSlide();
})();